import {customAxios} from "../customAxios";
import {useEffect, useState} from "react";
import {AdminVehicleFullDto, VehicleSimpleDto} from "../../model/Vehicle";
import {updateTenant} from "../tenants/useUpdateTenant";
import {createTenant} from "../tenants/useCreateTenant";
import {TenantDto} from "../../model/TenantDto";
import {UserDto} from "../../model/Users";
import {TaxCalculationResult, TaxResult, TestTaxDto} from "../../model/tax";

export function useTaxTest() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<TaxCalculationResult>();
    const [error, setError] = useState<Error>();

    async function execute(dto: TestTaxDto) {
        try {
            setLoading(true);
            setError(undefined);
            const data = await taxTest(dto);
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }


    return {
        loading, data, error, execute
    };
}

export async function taxTest(dto: TestTaxDto): Promise<TaxCalculationResult> {
    const response = await customAxios.post<TaxCalculationResult>('/v1/test/tax', dto);
    return response.data;
}
